// Onde cada aplicativo (Integrações → Painel de Aplicativos) aparece agora.
//
// O iframe de cada aplicativo é um só, criado na primeira vez que ele abre e
// mantido vivo na CamadaDeAplicativos (montada no App.vue): trocar de conversa
// ou de tela só o esconde, então o login e a navegação dentro do site ficam
// como num navegador. Quem mostra o aplicativo (a aba da conversa ou a tela
// cheia) é um PalcoDoAplicativo: ele avisa aqui qual área da tela ocupa, e a
// camada põe o iframe por cima dela.
import { reactive } from 'vue';

export const aplicativos = reactive({
  // Os ids já abertos (os iframes vivos).
  abertos: [],
  // O que está à vista e o elemento que ele cobre.
  ativo: null,
  alvo: null,
  // Muda quando a pessoa pede "Início": o iframe recomeça na URL cadastrada.
  recomecos: {},
});

export const mostra = (id, elemento) => {
  if (!aplicativos.abertos.includes(id)) aplicativos.abertos.push(id);
  aplicativos.ativo = id;
  aplicativos.alvo = elemento;
};

export const esconde = (id, elemento) => {
  if (aplicativos.ativo !== id || aplicativos.alvo !== elemento) return;
  aplicativos.ativo = null;
  aplicativos.alvo = null;
};

export const recomeca = id => {
  aplicativos.recomecos[id] = (aplicativos.recomecos[id] || 0) + 1;
};

// O endereço que o aplicativo abre (o primeiro quadro cadastrado).
export const enderecoDe = app =>
  (app?.content || []).find(item => item.type === 'frame' && item.url)?.url ||
  '';
